<div class="issue-repair-container" [testId]="'issue-repair-container'">
  <!-- 搜索區域 -->
  <div class="header-section" [testId]="'header-section'">
    <div class="title-section" [testId]="'title-section'">
      <h3 [testId]="'page-title'">{{ 'issue-repair.title' | i18n }}</h3>
    </div>
    <div class="action-section" [testId]="'action-section'">
      <div class="search-container" [testId]="'search-container'">
        <nz-input-group [nzSuffix]="suffixIconSearch" class="search-input" [testId]="'search-input-group'">
          <input
            type="text"
            nz-input
            [placeholder]="'issue-repair.search.placeholder' | i18n"
            [(ngModel)]="searchKeywords"
            (keyup.enter)="search()"
            [testId]="'search-input'"
          />
          <ng-template #suffixIconSearch [testId]="'search-icon-template'">
            <i
              nz-icon
              nzType="search"
              (click)="search()"
              class="search-icon"
              nz-tooltip
              [nzTooltipTitle]="'issue-repair.search.tooltip' | i18n"
              [testId]="'search-icon'"
            ></i>
          </ng-template>
        </nz-input-group>
        <!-- 只需修改按钮部分 -->
        <button nz-button nzType="default" (click)="reset()" class="reset-button" [testId]="'reset-button'">
          <i nz-icon nzType="clear" [testId]="'reset-icon'"></i>
          <span class="button-text" [testId]="'reset-button-text'">{{ 'issue-repair.sync-data' | i18n }}</span>
        </button>

        <nz-select
          [(ngModel)]="orderBy"
          (ngModelChange)="onSortChange($event)"
          [nzPlaceHolder]="'issue-repair.sort.placeholder' | i18n"
          class="sort-select"
          [testId]="'sort-select'"
        >
          <nz-option nzValue="issueTime" [nzLabel]="'issue-repair.sort.by-time' | i18n" [testId]="'sort-option-time'" />
          <nz-option nzValue="statusWeight" [nzLabel]="'issue-repair.sort.by-status' | i18n" [testId]="'sort-option-status'" />
        </nz-select>
      </div>
    </div>
  </div>

  <!-- 表格區域 -->
  <div class="table-container" [testId]="'table-container'">
    <nz-table
      #basicTable
      class="content-table"
      nzSize="small"
      [nzScroll]="{ x: '100%', y: 'calc(100vh - 200px)' }"
      [nzData]="listOfData"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzLoading]="loading"
      [testId]="'issue-repair-table'"
    >
      <thead [testId]="'table-header'">
        <tr [testId]="'header-row'">
          <th scope="col" nzWidth="160px" nzLeft [testId]="'header-issue-number'">{{ 'issue-repair.table.issue-number' | i18n }}</th>
          <th scope="col" nzWidth="307px" [testId]="'header-title'">{{ 'issue-repair.table.title' | i18n }}</th>
          <th scope="col" nzWidth="88px" [testId]="'header-type'">{{ 'issue-repair.table.type' | i18n }}</th>
          <th scope="col" nzWidth="122px" [testId]="'header-status'">{{ 'issue-repair.table.status' | i18n }}</th>
          <th scope="col" nzWidth="120px" [testId]="'header-reporter'">{{ 'issue-repair.table.reporter' | i18n }}</th>
          <th scope="col" nzWidth="142px" [testId]="'header-issue-time'">{{ 'issue-repair.table.issue-time' | i18n }}</th>
          <th scope="col" nzWidth="80px" [testId]="'header-platform'">{{ 'issue-repair.table.platform' | i18n }}</th>
          <th scope="col" nzWidth="88px" [testId]="'header-tenant'">{{ 'issue-repair.table.tenant' | i18n }}</th>
          <th scope="col" nzWidth="60px" nzRight [testId]="'header-actions'">{{ 'issue-repair.table.actions' | i18n }}</th>
        </tr>
      </thead>
      <tbody [testId]="'table-body'">
        <tr *ngFor="let item of listOfData; let i = index" [testId]="'data-row-' + i">
          <td nzLeft class="content-cell" [testId]="'cell-issue-number-' + i">{{ item.issueNumber }}</td>
          <td [testId]="'cell-title-' + i">
            <span class="content-cell" nz-tooltip [nzTooltipTitle]="item.name" [testId]="'title-span-' + i">{{ item.name }}</span>
          </td>
          <td [testId]="'cell-type-' + i">
            <span class="content-cell" nz-tooltip [nzTooltipTitle]="item.type" [testId]="'type-span-' + i">{{ item.type }}</span>
          </td>
          <td [testId]="'cell-status-' + i">
            <span class="content-cell" nz-tooltip [nzTooltipTitle]="item.status" [testId]="'status-span-' + i">{{ item.status }}</span>
          </td>
          <td [testId]="'cell-reporter-' + i">
            <span class="content-cell" nz-tooltip [nzTooltipTitle]="item.userName" [testId]="'reporter-span-' + i">{{
              item.userName
            }}</span>
          </td>
          <td [testId]="'cell-issue-time-' + i">
            <span class="content-cell" nz-tooltip [testId]="'issue-time-span-' + i">{{ item.issueTime | date: 'yyyy-MM-dd HH:mm' }}</span>
          </td>
          <td [testId]="'cell-platform-' + i">
            <span class="content-cell" nz-tooltip [nzTooltipTitle]="item.deviceType" [testId]="'platform-span-' + i">{{
              item.deviceType
            }}</span>
          </td>
          <td [testId]="'cell-tenant-' + i">
            <span class="content-cell" nz-tooltip [nzTooltipTitle]="item.tenantName" [testId]="'tenant-span-' + i">{{
              item.tenantName
            }}</span>
          </td>
          <td nzRight class="action-column" [testId]="'cell-actions-' + i">
            <div class="action-buttons" [testId]="'action-buttons-' + i">
              <button
                nz-button
                nzType="link"
                nzSize="small"
                (click)="viewDetail(item)"
                nz-tooltip
                [nzTooltipTitle]="'issue-repair.action.view-detail' | i18n"
                [testId]="'view-detail-button-' + i"
                >{{ 'issue-repair.action.view' | i18n }}</button
              >
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <!-- 分頁區域 -->
  <div class="pagination-container" *ngIf="total > 0" [testId]="'pagination-container'">
    <div class="pagination-info" [testId]="'pagination-info'"> {{ 'issue-repair.pagination.total' | i18n: { total: total } }} </div>
    <nz-pagination
      [testId]="'pagination'"
      nzSize="small"
      [nzShowQuickJumper]="true"
      [nzPageIndex]="pageIndex"
      [nzTotal]="total"
      [nzPageSize]="pageSize"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="[10, 20, 50, 100]"
      [nzShowTotal]="totalTemplate"
      (nzPageIndexChange)="onPageIndexChange($event)"
      (nzPageSizeChange)="onPageSizeChange($event)"
    />
    <ng-template #totalTemplate let-total let-range="range" [testId]="'pagination-template'">
      <span [testId]="'pagination-range'">{{ 'issue-repair.pagination.per-page' | i18n: { pageSize: pageSize } }}</span>
    </ng-template>
  </div>
</div>
